import { useState } from "react";

const OptionsBtn = ({ isLoadingClusterData, addKeywordsHandler, removeKeywordsHandler, deleteClusterHandler, canDelete }: {
  isLoadingClusterData: boolean;
  addKeywordsHandler: () => void;
  removeKeywordsHandler: () => void;
  deleteClusterHandler: () => void;
  canDelete: boolean;
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  return (
    <div className="relative">
      <button
        className="rounded-full bg-my-purple py-[14px] px-[18px] flex items-center gap-1.5"
        onClick={() => setIsMenuOpen(prev => !prev)}
      >
        <img src='/icons/options.svg' />
        <span className="font-semibold leading-[1] text-white">Options</span>
      </button>

      {isMenuOpen && (
        <>
          <div
            className="menu-backdrop"
            onClick={() => setIsMenuOpen(false)}
          />
          <div className="p-2 rounded-lg bg-white shadow-sm z-20 absolute right-0 top-[calc(100%+4px)]">
            <button
              className="dropdown-item"
              onClick={() => {
                addKeywordsHandler();
                setIsMenuOpen(false);
              }}
              disabled={isLoadingClusterData}
            >
              Add Keywords
            </button>

            <button
              className="dropdown-item"
              onClick={() => {
                removeKeywordsHandler();
                setIsMenuOpen(false);
              }}
              disabled={isLoadingClusterData || !canDelete}
              title={
                canDelete
                  ? "Remove keywords"
                  : "Only tenant admins can delete keywords"
              }
            >
              Remove Keywords
            </button>

            <div className="w-full h-[1px] bg-neutral-200 my-1"></div>

            <button
              className="dropdown-item delete-item"
              onClick={() => {
                deleteClusterHandler();
                setIsMenuOpen(false);
              }}
              disabled={isLoadingClusterData}
            >
              Delete Cluster
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default OptionsBtn;